import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";
import { LEADERSHIP } from "@/lib/sipl-content";

export default function Leadership() {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="section-y bg-sipl-bg"
    >
      <div className="container-x">
        <div className="max-w-2xl mb-14">
          <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-4 dash-accent">
            Leadership
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-sipl-primary font-semibold tracking-tight leading-[1.08]">
            Decades of public-sector engineering, distilled into private execution.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {LEADERSHIP.map((p, idx) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: idx * 0.08 }}
              data-testid={`leader-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              className="sipl-card p-8 flex flex-col"
            >
              <div className="flex items-start gap-5">
                <div className="w-20 h-20 rounded-md bg-gradient-to-br from-sipl-primary to-sipl-secondary flex items-center justify-center text-white font-heading text-2xl font-semibold shrink-0">
                  {p.initials}
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-xl font-medium text-sipl-primary leading-tight">
                    {p.name}
                  </h3>
                  <div className="text-sm text-sipl-secondary mt-1 font-medium">
                    {p.role}
                  </div>
                </div>
                <a
                  href={p.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`leader-linkedin-${p.initials}`}
                  className="text-sipl-muted hover:text-sipl-primary transition-colors"
                  aria-label={`${p.name} on LinkedIn`}
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>

              <p className="mt-6 text-sipl-fg/75 text-sm leading-relaxed">
                {p.bio}
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {p.tags.map((t) => (
                  <span
                    key={t}
                    className="text-[11px] uppercase tracking-[0.16em] px-2.5 py-1 rounded-sm bg-sipl-mute text-sipl-primary border border-sipl-line"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
